import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssinaturaComponent } from './pages/assinatura/assinatura.component';
import { HomeComponent } from './pages/home/home.component';
import { TiktokComponent } from './pages/tiktok/tiktok.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'tiktok', component: TiktokComponent },
 // { path: 'assinatura/:id', component: AssinaturaComponent },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
